module.exports = __webpack_public_path__ + "static/media/logo.2c2c7a04.png";